import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import CookieConsent from '../CookieConsent';
import GoogleAd from '../GoogleAd';
import { AD_SLOTS } from '../adSlots';

const Layout = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [pathname]);

    return (
        <div className="App">
            <Header />
            <main className="page-main">
                <Outlet />
                <GoogleAd slot={AD_SLOTS.LAYOUT_BOTTOM} className="ad-slot-layout-bottom" />
            </main>
            <Footer />
            <CookieConsent />
        </div>
    );
};

export default Layout;
